export const projectEndpoints = {
  GetById: 'api/Project/',
  GetProjectDropDownList: 'api/Project/DropDown',
  GetProjectModule: 'api/ProjectModule/GetByProjectId/',
  GetProjectTypes: 'api/ProjectTaskType/GetAllByProjectId',
  getProjectList: '/api/Project/ProjectList',
  getProjectStatus: '/api/Project/Status',
  getEmployeesAllAssigned: '/api/Employee/GetAllAssigned',
  getClientFilter: '/api/Client/Filter',
  getProjectDetailsById: '/api/Project/ProjectDetail',
  getProjectDashboards: '/api/Dashboard/GetProjectDashboard',
  getProjectDetails: '/api/Project',
  getProjectFiles: '/api/ProjectFolder/Filter',
  createProjectFolder: '/api/ProjectFolder/Insert',
  deleteProjectFolder: '/api/ProjectFiles/Delete',
  createProjectFile: '/api/ProjectFiles/Insert',

  getProjectFolderMembersByFolderId: '/api/ProjectFolderMember/GetFolderMembers',
  getProjectSubFolders: '/api/ProjectFolder/GetByFolderId',

  getEmployeeChartForTeam: '/api/Employee/GetEmployeeChartForTeam',
  getAllTaskAndSubTask: '/api/Task/GetAllTaskAndSubTaskBySP',

  createProject: '/api/Project/Insert',
  getProjectNotes: '/api/ProjectNotes/GetByProjectId',
  createProjectNotes: '/api/ProjectNotes/Insert',

  getIssueList: '/api/Issue/Filter',
  createProjectIssue: '/api/Issue/Insert',

  issueFileUpload: 'api/IssueFile/Upload',
  issueFileDelete: 'api/IssueFile/Delete',

  getIssueDetails: '/api/Issue',

  changeIssueStatus: '/api/Issue/ChangeStatus',

  deleteIssue: '/api/Issue/Delete',
  deleteNote: '/api/ProjectNotes/Delete',

  updateProject: '/api/Project/Update',

  updateProjectStatus: '/api/Project/ChangeStatus',

  archiveProject: '/api/Project/Archive',
  getMilestone: '/api/MileStone/Filter',
  getMilestoneTasks: '/api/Task/GetAllBySP',

  createMilestone: '/api/MileStone/Insert',
  deleteMilestone: '/api/MileStone/Delete',
  getMilestoneDetails: '/api/MileStone',
  removeMiletoneTask: '/api/MileStone/TaskBindWithMileStone',
  getTaskCompletionByProject: '/api/Dashboard/GetTaskCompletionByProject',

};
